<template>
    <div class="firm-info-details">
        <p v-if="firm.nameAffix" class="mb-1">
            {{ firm.nameAffix }}
        </p>
        <p class="mb-0">
            {{ firm.address }}
        </p>
    </div>
</template>

<script>
    export default {
        props: {
            firm: {
                type: Object,
                required: true,
            },
        },
    }
</script>
